// src/components/LlmProcessingCard/LlmFlowDiagram/LlmFlowDetails.js
import React, { useRef, useEffect } from "react";
import { Box, Paper, Typography } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

function LlmFlowDetails({
  selectedBlockId,
  selectedSubunitId,
  detailsConfig,
}) {
  const detailsRef = useRef(null);

  // Auto-scroll to details when a block/subunit is selected
  useEffect(() => {
    if (selectedBlockId && detailsRef.current) {
      detailsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedBlockId, selectedSubunitId]);

  let title = "";
  let description = "";
  let items = [];

  if (!selectedBlockId) {
    title = "Click on a block, or on subunits to see what they contain.";
    description = "";
  } else {
    const blockDetails = detailsConfig?.[selectedBlockId] || {};
    const key = selectedSubunitId || "_self";
    const detail = blockDetails[key] || {};

    title = detail.title || "Details";
    description = detail.description || "";
    items = Array.isArray(detail.items) ? detail.items : [];
  }

  return (
    <Box ref={detailsRef}>
      {/* Down arrow hint connecting blocks to details */}
      {selectedBlockId && (
        <Box sx={{ display: "flex", justifyContent: "center", my: 0.5 }}>
          <ArrowDownwardIcon sx={{ color: "primary.main", fontSize: 20 }} />
        </Box>
      )}

      <Paper
        variant="outlined"
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: selectedBlockId ? "grey.50" : "grey.50",
          borderColor: selectedBlockId ? "primary.main" : "grey.300",
          borderWidth: selectedBlockId ? 2 : 1,
          transition: "border-color 0.3s, border-width 0.3s",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            mb: 0.5,
            color: selectedBlockId ? "primary.main" : "text.primary",
          }}
        >
          {title}
        </Typography>

        {description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: items.length ? 1 : 0 }}
          >
            {description}
          </Typography>
        )}

        {items.length > 0 && (
          <Box component="ul" sx={{ pl: 2, mb: 0 }}>
            {items.map((item) => (
              <li key={item}>
                <Typography variant="body2" color="text.secondary">
                  {item}
                </Typography>
              </li>
            ))}
          </Box>
        )}
      </Paper>
    </Box>
  );
}

export default LlmFlowDetails;
